export function showDealerSearchDropdown(country: string): boolean {
  const countriesWithDropdown = ['CN'];

  return countriesWithDropdown.includes(country);
}

export function getRegionSpecificCountry(country: string): string {
  return country.includes('-') ? country.split('-')[0] : country;
}

export function sanitizeDealerHomepage(originalUrl: string): string {
  if (!originalUrl.startsWith('https://')) {
    return `http://${originalUrl}`;
  }

  return originalUrl;
}
